"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackLink = exports.className = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../utils/classFunctions");
const Icon_1 = require("../Icon");
require("./index.scss");
exports.className = 'back-link';
const defaultText = (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/BackLink:label', defaultMessage: 'Back' }));
const BackLink = (props) => {
    const { to, modificators, text = defaultText } = props;
    const classNames = (0, classFunctions_1.getClassNames)(exports.className, modificators);
    if (!to)
        return null;
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(exports.BackLink.Link, { to: to },
            react_1.default.createElement("span", { className: `${exports.className}__icon` },
                react_1.default.createElement(Icon_1.Icon, { name: 'back' })),
            react_1.default.createElement("span", { className: `${exports.className}__text` }, text))));
};
exports.BackLink = BackLink;
// ToDo: Remove this hack
exports.BackLink.Link = (({ children }) => children);
//# sourceMappingURL=index.js.map